const CompetitionGroupCompetitionInitialValues = (showData) => ({
  competition_ids: showData?.data?.competitions?.map((competition) => competition.id) || [],
});

export default CompetitionGroupCompetitionInitialValues;
